/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const usaGeneralData = {
  population: '327 million',
  laborForce: '161.0 million',
  unemploymentRate: '3.8%',
  gdpPerCapita: '62,500 US dollars',
  fashionMarketShare: '4 percent',
  domesticMarketValue: '406 billion dollars',
  fashionEmployment: '1.9 million'
};
export const nycFashionData = {
  population: '8.55 million',
  laborForce: '4.2 million',
  fashionEmployment: '185,000',
  fashionWages: '11 billion dollars',
  fashionTaxRevenue: '2 billion dollars'
};
export const fashionEmploymentByCategory = [{
  category: 'Apparel Retailers',
  percentage: 79,
  employees: 1422000,
  avgWage: 26650
}, {
  category: 'Apparel Wholesale',
  percentage: 8,
  employees: 145000,
  avgWage: 52350
}, {
  category: 'Apparel Manufacturing',
  percentage: 8,
  employees: 143000,
  avgWage: 34110
}, {
  category: 'Fashion Designers',
  percentage: 1,
  employees: 18000,
  avgWage: 73690
}];
export const apparelManufacturingTrend = [{
  year: '1990',
  value: 14.5
}, {
  year: '1995',
  value: 13.1
}, {
  year: '2000',
  value: 13.0
}, {
  year: '2014',
  value: 24.8
}];
export const textilesTrend = [{
  year: '1990',
  value: 19.7
}, {
  year: '1995',
  value: 16.8
}, {
  year: '2000',
  value: 13.5
}, {
  year: '2014',
  value: 33.0
}];
export const textilesAndClothingTrend = [{
  year: '1990',
  value: 34.2
}, {
  year: '1995',
  value: 29.9
}, {
  year: '2000',
  value: 26.5
}, {
  year: '2014',
  value: 57.8
}];
export const topUSFashionCompanies = [{
  name: 'Nike',
  marketValue: 105,
  revenue: 30.6,
  category: 'Athleisure'
}, {
  name: 'TJX Companies',
  marketValue: 54.5,
  revenue: 30.9,
  category: 'Fast Fashion'
}, {
  name: 'VF Corporation',
  marketValue: 27.6,
  revenue: 12.4,
  category: 'Outdoor/Action'
}, {
  name: 'L Brands',
  marketValue: 25.3,
  revenue: 12.15,
  category: 'Intimate Apparel'
}, {
  name: 'Under Armour',
  marketValue: 17.8,
  revenue: 4.0,
  category: 'Sports'
}];
export const textileExports2016 = [{
  name: 'Raw cotton',
  value: 4.41,
  percentage: 19
}, {
  name: 'Nonwoven textiles',
  value: 1.77,
  percentage: 8
}, {
  name: 'Cotton yarn',
  value: 1.13,
  percentage: 5
}, {
  name: 'Artificial filament tow',
  value: 1.04,
  percentage: 4.5
}, {
  name: 'Synthetic filament yarn',
  value: 1.03,
  percentage: 4.5
}];
export const footwearExports2016 = [{
  name: 'Footwear, leather body',
  value: 306,
  percentage: 27
}, {
  name: 'Parts of footwear',
  value: 263,
  percentage: 23
}, {
  name: 'Other headgear',
  value: 139,
  percentage: 12
}, {
  name: 'Footwear, textile body',
  value: 85.4,
  percentage: 7.5
}, {
  name: 'Footwear, rubber/plastics',
  value: 76.9,
  percentage: 7
}];
export const clothingImports2016 = [{
  name: 'Sweaters, pullovers',
  value: 14.1,
  percentage: 13
}, {
  name: 'Womens suits, not knit',
  value: 9.37,
  percentage: 9
}, {
  name: 'Mens suits, not knit',
  value: 8.2,
  percentage: 8
}, {
  name: 'Womens suits',
  value: 5.63,
  percentage: 5
}, {
  name: 'T-shirts',
  value: 5.2,
  percentage: 5
}];
export const footwearImports2016 = [{
  name: 'Footwear, leather body',
  value: 12.2,
  percentage: 42
}, {
  name: 'Footwear, rubber/plastics',
  value: 6.64,
  percentage: 23
}, {
  name: 'Footwear, textile body',
  value: 4.7,
  percentage: 16
}, {
  name: 'Hats, knitted/crocheted',
  value: 1.34,
  percentage: 5
}];
export const salaryRangesByOccupation = [{
  occupation: 'Marketing/Sales Managers',
  salary: 84600,
  category: 'High'
}, {
  occupation: 'Fashion Designers',
  salary: 73690,
  category: 'High'
}, {
  occupation: 'Accountants/Auditors',
  salary: 69960,
  category: 'High'
}, {
  occupation: 'Buyers/Purchasing Agents',
  salary: 56550,
  category: 'Medium'
}, {
  occupation: 'Graphic Designers',
  salary: 48320,
  category: 'Medium'
}, {
  occupation: 'Apparel Retail Average',
  salary: 26650,
  category: 'Low'
}, {
  occupation: 'Tailors/Dressmakers',
  salary: 27510,
  category: 'Low'
}, {
  occupation: 'Textile Machine Operators',
  salary: 26440,
  category: 'Low'
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    em: "em",
    ul: "ul",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components), {ChartGrid} = _components;
  if (!ChartGrid) _missingMdxReference("ChartGrid", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population"
            })
          }), _jsx(_components.td, {
            children: "327 million"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force"
            })
          }), _jsx(_components.td, {
            children: "161.0 million"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate"
            })
          }), _jsx(_components.td, {
            children: "3.8%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "GDP per capita (PPS)"
            })
          }), _jsx(_components.td, {
            children: "62,500 US dollars"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Market share of the fashion industry"
            })
          }), _jsx(_components.td, {
            children: "4 percent"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Domestic market value of the fashion industry"
            })
          }), _jsx(_components.td, {
            children: "406 billion dollars"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Employment in fashion-related industries"
            })
          }), _jsx(_components.td, {
            children: "1.9 million"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "New York: Fashion capital"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "New York City population"
          }), _jsx(_components.td, {
            children: "8.55 million"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "New York City labor force"
          }), _jsx(_components.td, {
            children: "4.2 million"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Employment in fashion-related industries (NYC only)"
          }), _jsx(_components.td, {
            children: "185,000"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Wages in the fashion industry (NYC only)"
          }), _jsx(_components.td, {
            children: "11 billion dollars"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Fashion industry tax revenue (NYC only)"
          }), _jsx(_components.td, {
            children: "2 billion dollars"
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "source: NYCEDC (US Census Bureau)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Employment"
    }), "\n", _jsx(_components.p, {
      children: "In the United States an estimated 1.8 million people are employed in the fashion industry, among whom 232,000 in manufacturing textiles for apparel and other fashion items."
    }), "\n", _jsx(PieChart, {
      data: fashionEmploymentByCategory,
      title: "US Fashion Employment Distribution (%)",
      dataKey: "percentage",
      nameKey: "category",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "About 79 percent of all US employees in fashion work for apparel retailers. The average annual wage at such companies is 26,650 dollars."
    }), "\n", _jsx(BarChart, {
      data: salaryRangesByOccupation,
      title: "Fashion Industry Salary Ranges by Occupation (USD)",
      dataKey: "salary",
      xAxisKey: "occupation",
      valuePrefix: "$",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Average annual wages in fashion range from 26,440 dollars, for textile bleaching and dyeing machine operators, to 84,600 dollars for marketing and sales managers in fashion."
    }), "\n", _jsx(_components.p, {
      children: "Apart from the jobs listed before, the United States has room for around 18,000 fashion designers. Their average annual wage is 73,690 dollars, meaning that they receive over 30 dollars per hour."
    }), "\n", _jsx(_components.h3, {
      children: "Apparel manufacturing"
    }), "\n", _jsx(LineChart, {
      data: apparelManufacturingTrend,
      title: "US Apparel Manufacturing Trend (millions)",
      dataKey: "value",
      xAxisKey: "year",
      valueSuffix: "M"
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(LineChart, {
        data: textilesTrend,
        title: "US Textiles Production Trend (millions)",
        dataKey: "value",
        xAxisKey: "year",
        valueSuffix: "M"
      }), _jsx(LineChart, {
        data: textilesAndClothingTrend,
        title: "US Textiles and Clothing Combined Trend (millions)",
        dataKey: "value",
        xAxisKey: "year",
        valueSuffix: "M"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Fashion companies"
    }), "\n", _jsx(_components.p, {
      children: "Some of the world's largest fashion companies are based in the United States. Nike is the currently largest fashion company globally."
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: topUSFashionCompanies,
        title: "Top US Fashion Companies by Market Value (billions USD)",
        dataKey: "marketValue",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "B",
        layout: "vertical"
      }), _jsx(BarChart, {
        data: topUSFashionCompanies,
        title: "Top US Fashion Companies by Revenue (billions USD)",
        dataKey: "revenue",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "B",
        layout: "vertical"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Nike is an athleisure- and lifestyle brand with annual revenues of 30.6 billion and a market value of nearly 105 billion dollars. Nike offers its products worldwide and its largest markets are the United States, accounting for 46 percent of the total revenues, and Western Europe (19 percent)."
    }), "\n", _jsx(_components.p, {
      children: "TJX Companies is the second largest fashion company in the United States with a market value of 54.5 billion dollars and 2015 annual sales of 30.9 billion dollars. TJX operates the majority of its stores in the United States and is best known for its fast-fashion brand T.J. Maxx."
    }), "\n", _jsx(_components.p, {
      children: "VF Corporation is the third largest fashion company in the United States. VF owns several brands including Lee, The North Face, Timberland and Napapijri. In 2015 VF's annual revenue rose to 12.4 billion dollars."
    }), "\n", _jsx(_components.h2, {
      children: "Imports & Exports (2016)"
    }), "\n", _jsx(_components.h3, {
      children: "Exports of textiles and clothing: 22.9 billion dollars"
    }), "\n", _jsx(_components.p, {
      children: "The United States are not one of the largest exporters of fashion-related products in the world, however it still supplies a fair share of several textiles for fashion purpose to overseas markets."
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: textileExports2016,
        title: "US Textile Exports 2016 (billions USD)",
        dataKey: "value",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "B",
        layout: "vertical"
      }), _jsx(BarChart, {
        data: footwearExports2016,
        title: "US Footwear & Headwear Exports 2016 (millions USD)",
        dataKey: "value",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "M",
        layout: "vertical"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Imports of clothing: 105 billion dollars"
    }), "\n", _jsx(_components.p, {
      children: "The United States are the largest importer of fashion-related products in the world. It mostly imports manufactured apparel."
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: clothingImports2016,
        title: "US Clothing Imports 2016 (billions USD)",
        dataKey: "value",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "B",
        layout: "vertical"
      }), _jsx(BarChart, {
        data: footwearImports2016,
        title: "US Footwear & Headwear Imports 2016 (billions USD)",
        dataKey: "value",
        xAxisKey: "name",
        valuePrefix: "$",
        valueSuffix: "B",
        layout: "vertical"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Sources"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Import and export data: OEC"
      }), "\n", _jsx(_components.li, {
        children: "Largest companies Info: FashionUnited top 100"
      }), "\n", _jsxs(_components.li, {
        children: ["Population and Labour Data: World Bank | ", _jsx(_components.a, {
          href: "http://www.wto.org",
          children: "www.wto.org"
        })]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
